import ICMWrapper from "@/app/components/icm-wrapper";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import Image, { StaticImageData } from "next/image";
import React, { useMemo, useState } from "react";
import HowTo1 from "@/app/assets/images/investment-global-stocks-1.png";
import HowTo2 from "@/app/assets/images/investment-global-stocks-2.png";
import HowTo3 from "@/app/assets/images/investment-global-stocks-3.png";
import DownloadAppPlusIconsWhite from "@/app/global/components/download-app-plus-icons-white";
import {
    generalProdctType,
    getRouteWiseProduct,
    productRoute,
    ProductRoute,
} from "@/types/product";
import { toTitleCase } from "@/app/utils/helper";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { DirectPaths } from "@/config/routes";
import GetICMAppModal from "@/app/components/get-icm-app-modal";

interface StepProps {
    imgUrl: StaticImageData;
    title: string;
    subtitle: string | JSX.Element;
}

interface HowtoInvestProps {
    title?: string;
    pageRoute?: ProductRoute;
}

const HowToInvest: React.FC<HowtoInvestProps> = ({ pageRoute }) => {
    const stocks: StepProps[] = [
        {
            title: "Quick Sign-up",
            subtitle:
                "Complete your account setup and digital KYC in a few simple steps to get started with global investing.",
            imgUrl: HowTo1,
        },
        {
            title: " Fund your account",
            subtitle:
                " Transfer funds from your Indian bank account under the RBI’s Liberalised Remittance Scheme (LRS) through the supported banking process.",
            imgUrl: HowTo2,
        },
        {
            title: "Start Investing in US Stocks",
            subtitle:
                "Explore and invest in US-listed companies across sectors and themes that align with your investment preferences.",
            imgUrl: HowTo3,
        },
    ];

    const etfs: StepProps[] = [
        {
            title: "Quick Sign-up",
            subtitle:
                "Complete your account setup and digital KYC in a few simple steps to get started with global investing.",
            imgUrl: HowTo1,
        },
        {
            title: " Fund your account",
            subtitle:
                "Transfer funds from your Indian bank account under the RBI’s Liberalised Remittance Scheme (LRS) through the supported banking process.",
            imgUrl: HowTo2,
        },
        {
            title: "Start Investing in US ETFs",
            subtitle:
                "Explore and invest across sectors and themes that align with your investment preferences.",
            imgUrl: HowTo3,
        },
    ];

    const [showAppModal, setShowAppModal] = useState<boolean>(false);

    const toggleDownloadApp = () => {
        setShowAppModal(!showAppModal);
    };

    const globalPagePath = useMemo(() => {
        return pageRoute === productRoute["us-stocks"]
            ? `${DirectPaths.GLOBAL + DirectPaths.US_STOCKS}`
            : (pageRoute === productRoute["us-etfs"] &&
                  `${DirectPaths.GLOBAL + DirectPaths.US_ETFS}`) ||
                  "";
    }, [pageRoute]);

    const eventNameFold2 = useMemo(() => {
        return `Home_Explore_Global_${pageRoute?.toUpperCase().replace("-", "_")}_Fold2`;
    }, [pageRoute]);

    return (
        <section
            className={`bg-[url('https://assets.incredmoney.com/images/webp/how-to-invest.webp')] bg-[length:90%] bg-no-repeat py-14 md:bg-[length:35%] md:py-32 ${pageRoute === productRoute["us-stocks"] ? "bg-[#334155]" : "bg-[#6B929C]"}`}
        >
            <h2 className="ml-auto mr-auto max-w-[80%] text-center text-4xl font-semibold text-white md:text-7xl">
                Process of Investing in US{" "}
                {pageRoute === productRoute["us-stocks"]
                    ? toTitleCase(getRouteWiseProduct({ route: pageRoute! })) + "s"
                    : pageRoute === productRoute["us-etfs"] && generalProdctType.ETF}
            </h2>
            <ICMWrapper>
                <div className="relative flex flex-col items-start justify-between gap-12 py-10 sm:flex-row sm:gap-20 md:mb-3">
                    {(pageRoute === productRoute["us-stocks"] ? stocks : etfs).map(
                        (step, index) => {
                            return (
                                <div className="flex-1" key={index}>
                                    <div className="mb-7 rounded-[40px] bg-white">
                                        <Image
                                            src={step.imgUrl}
                                            alt={step.title}
                                            className="mx-auto"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <h5 className="text-xl font-semibold leading-loose text-white">
                                            {step.title}
                                        </h5>
                                        <p className="leading-relaxed text-white">
                                            {step.subtitle}
                                        </p>
                                    </div>
                                </div>
                            );
                        },
                    )}
                </div>

                <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <RegularButton
                        noIcon
                        showRightIcon={true}
                        rightIcon={<DownloadAppPlusIconsWhite />}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        label="Download the app"
                        className="mb-2 w-full max-w-full bg-white sm:max-w-fit md:mb-0 h-[60px]"
                        // onClick={() => (window.location.href = process.env.ICM_PLAYSTORE_URL || "")}
                        onClick={() => {
                            setAnalyticsEvent(`${globalPagePath}`, `${eventNameFold2}`);
                            toggleDownloadApp();
                        }}
                    />
                    {/*  <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                        label="Start Investing"
                        onClick={() => {
                            setAnalyticsEvent(
                                `${process.env.ICM_GLOBAL_POST_URL || ""}/login`,
                                "US_Listing_Page_Start_Investing_Fold4",
                            );
                            window.location.href = process.env.ICM_GLOBAL_POST_URL + "/login";
                        }}
                    /> */}
                </div>

                <GetICMAppModal open={showAppModal} onClose={toggleDownloadApp} />
            </ICMWrapper>
        </section>
    );
};

export default HowToInvest;
